import { h, ComponentChildren, JSX } from 'preact';
import * as styles from './styles.less';

interface ButtonProps {
    children: ComponentChildren;
    status?: STATUS;
    type?: 'submit' | 'reset' | 'button';
    href?: string;
    native?: boolean | null;
    onClick?: JSX.MouseEventHandler<HTMLButtonElement>;
    size?: 'xsmall' | 'small' | 'medium' | 'large';
    appearance?: 'primary' | 'secondary' | 'reset' | 'login' | 'register' | 'text' | 'helper-remove';
    target?: string;
    fullwidth?: boolean;
    id?: string;
    testId?: string;
}

export enum STATUS {
    TYPING = 'typing',
    VALID = 'valid',
    SUBMITTING = 'submitting',
    DISABLED = 'disabled',
}

const Button = ({ children, status, type = 'submit', href, native = true, onClick = undefined, size = 'medium', appearance = 'primary', target, fullwidth = false, id, testId }: ButtonProps) => {
    const statusClassName = status ? `${styles[status]}` : ``;
    const dataAttributes: { [key: string]: string } = {};
    if (testId) {
        dataAttributes['data-testid'] = testId;
    }
    if (id) {
        dataAttributes['data-id'] = id;
    }

    if (href) {
        return (
            <a class={`${styles.btn} ${statusClassName} ${styles[appearance]} ${styles[size]} ${fullwidth && styles.fullwidth}`} href={href} data-native={native} target={target} {...dataAttributes}>
                {children}
            </a>
        );
    }

    if (onClick) {
        return (
            <button type={type} class={`${styles.btn} ${statusClassName} ${styles[appearance]} ${styles[size]}`} onClick={onClick} {...dataAttributes}>
                {children}
            </button>
        );
    }

    return (
        <button type={type} class={`${styles.btn} ${statusClassName} ${styles[appearance]} ${styles[size]}`} {...dataAttributes}>
            {children}
        </button>
    );
};

export default Button;
